import React from 'react';
import { FilterBar } from '@ui';
/**
 * The surface's multi-select filters plus the search input, all client-side over the
 * already-loaded list. Which filters exist is the surface's own config — this component only
 * renders them.
 */
export function AttachmentsFilterBar({ searchId, search, onSearchChange, searchPlaceholder, filters, options, selections, onFilterChange }) {
    const filterConfigs = filters.map((filter) => {
        var _a, _b;
        return ({
            type: 'multiSelect',
            field: filter.key,
            label: filter.label,
            value: (_a = selections[filter.key]) !== null && _a !== void 0 ? _a : [],
            onChange: (values) => onFilterChange(filter.key, values),
            options: (_b = options[filter.key]) !== null && _b !== void 0 ? _b : []
        });
    });
    return (React.createElement(FilterBar, { filters: filterConfigs, showSearch: true, searchValue: search, onSearchChange: onSearchChange, searchPlaceholder: searchPlaceholder, searchId: searchId }));
}
